var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('referral-link'),_c('metrics-dashboard'),_c('total-deposit',{attrs:{"error-get-deposit":_vm.errorGetDeposit}}),_c('statistics-total-user')],1)}
var staticRenderFns = []

export { render, staticRenderFns }